import { generateRequest } from './request.js';
import { AveRequestEvents } from '../events.js';
/**
 * Return a list of all known driving scenes.
 *
 * Example:
 * ```
 * [{
 *   "meta": {
 *     "name": "AVEListDrivingScenes",
 *     "type": "REQUEST"
 *   },
 *   "data": {}
 * }]
 * ```
 */
export function generateListDrivingScenesRequest({ messageId } = {}) {
    return generateRequest({ messageId, name: AveRequestEvents.AVEListDrivingScenes });
}
/**
 * Load the specified driving scene level and plays its sequence.
 *
 * Limitations:
 * - Not available while an environment is loading.
 * - Not available when another car is loading.
 * - Not available when an experience is active.
 * - Not available when a driving scene is already active.
 * - Not available while rendering an image sequence.
 * - Not available while rendering an image job.
 * - Not available when orbit sequence is active.
 *
 * Notes:
 * - No other interactions with the AVE are allowed while driving scene is running/active.
 * - There is no AVEDrivingSceneFinished update when the driving scene is stopped by AVEDrivingSceneStop.
 *
 * Example:
 * ```
 * [{
 *   "meta": {
 *     "name": "AVEDrivingSceneStart",
 *     "type": "REQUEST"
 *   },
 *   "data": {
 *     "name": "<driving scene name>"
 *   }
 * }]
 * ```
 */
export function generateDrivingSceneStartRequest({ name, messageId }) {
    return generateRequest({ messageId, name: AveRequestEvents.AVEDrivingSceneStart, data: { name } });
}
/**
 * Stop any running driving scene and restore the formerly used environment.
 *
 * Notes:
 * - Restores the formerly used environment using the configured default camera.
 *
 * Example:
 * ```
 * [{
 *   "meta": {
 *     "name": "AVEDrivingSceneStop",
 *     "type": "REQUEST"
 *   },
 *   "data": {}
 * }]
 * ```
 */
export function generateDrivingSceneStopRequest({ messageId } = {}) {
    return generateRequest({ messageId, name: AveRequestEvents.AVEDrivingSceneStop });
}
//# sourceMappingURL=driving-scene.js.map